import { useQuery } from '@tanstack/react-query';
import { useApi } from './client.js';

interface Capabilities {
  accelerationTier: { enabled: boolean };
}

/**
 * Whether this deployment has the acceleration tier (CSAGE-437). Reads
 * GET /capabilities, which answers from the API's own configuration.
 *
 * `undefined` while loading. Callers offer tier-dependent actions only on an
 * explicit `true`, so a deployment without the tier never shows, even briefly,
 * an action that would fail.
 */
export function useAccelerationTierEnabled(): boolean | undefined {
  const api = useApi();
  const q = useQuery({
    queryKey: ['capabilities'],
    queryFn: () => api.fetch<Capabilities>('/capabilities'),
    staleTime: Infinity,
  });
  return q.data?.accelerationTier.enabled;
}
